export const checkIfAboutCinemaNotEmpty = _.memoize(aboutCinema =>
	!_.isEmpty(aboutCinema) && !/^(<p>\s*<\/p>\n?)+$/.test(aboutCinema));
